import { render, staticRenderFns } from "./PdpBuildABundleCta.vue?vue&type=template&id=23e06d8b&scoped=true&"
import script from "./PdpBuildABundleCta.vue?vue&type=script&lang=js&"
export * from "./PdpBuildABundleCta.vue?vue&type=script&lang=js&"
import style0 from "./PdpBuildABundleCta.vue?vue&type=style&index=0&id=23e06d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e06d8b",
  null
  
)

export default component.exports